export const pageToLoadOnDelete = (
	totalItems,
	totalItemsDeleted,
	pageNow,
	pageSize
) => {
	let maxPage = (totalItems - totalItemsDeleted) / pageSize;
	if (pageNow - maxPage > 0 && pageNow - maxPage < 1) return pageNow;
	if (pageNow < maxPage) return pageNow;
	else if (pageNow === 1) return pageNow;
	else return maxPage;
};
